import { ChangeDetectionStrategy, Component, Input, Optional, Self } from '@angular/core';
import { NgControl } from '@angular/forms';
import { ValidationMessageService } from '@common/services/validation-message.service';
import { PopupSettings } from '@progress/kendo-angular-dateinputs';
import { AbstractFormControlComponent } from './abstract-form-control.component';

@Component({
    selector: 'form-datetime',
    styleUrls: ['form-controls.component.scss'],
    template: `
        <div class="form-group" [ngClass]="{ 'has-value': !!value || hasValue }">
            <label class="col-form-label">
                {{ labelText }}
            </label>
            <app-control
                [type]="'datetime'"
                [kendoType]="'datetime'"
                [isDisabled]="isDisabled"
                [ngClass]="{ 'is-invalid': isInvalid }"
                [isInvalid]="isInvalid"
                [formControlValidators]="getFormControlValidators"
                [contextual]="contextual"
                [hidePickerButton]="hidePickerButton"
                [datePopupSettings]="datePopupSettings"
                [(ngModel)]="value"
                (ngModelChange)="changeValue($event)"
                (focus)="focusInHandler()"
                (blur)="focusOutHandler()"></app-control>
        </div>
    `,
    providers: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DatetimeComponent extends AbstractFormControlComponent {
    @Input()
    labelText: string;
    @Input()
    contextual: string = null;
    @Input() hasValue = false;
    @Input() isDisabled = false;
    @Input() hidePickerButton = false;
    @Input() datePopupSettings: PopupSettings;

    constructor(@Self() @Optional() controlDir: NgControl, validationMessageService: ValidationMessageService) {
        super(controlDir, validationMessageService);
    }

    maybeApplyActive() {
        this.hasValue = !!this.value;
    }

    focusInHandler() {
        this.hasValue = !!this.value || !this.isDisabled;
    }

    focusOutHandler() {
        this.hasValue = false;
        this.maybeApplyActive();
    }
}
